'use client';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

import ListSection from './Section/ListSection';
import TitleSection from './Section/TitleSection';

export default function StoreContainer() {
  const { teamSlug } = useTeamConfig();

  return (
    <div
      className="flex flex-col items-center gap-8 bg-store-list-container-bg px-5 pt-10 pb-football-page-bottom"
      style={{
        backgroundImage: `url('https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/store/bg.webp')`,
        backgroundSize: '480px auto',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <TitleSection />
      <ListSection />
    </div>
  );
}
